export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Work", href: "#portfolio" },
  { label: "Pricing", href: "#pricing" },
  { label: "Blog", href: "/blog" },
  { label: "Contact", href: "#contact" },
];

export const SERVICES = [
  { key: "seo", title: "Search Engine Optimization", icon: "Search",
    desc: "Rank higher, capture intent, and win compounding organic traffic that converts.", span: "lg:col-span-2" },
  { key: "smm", title: "Social Media Marketing", icon: "Share2",
    desc: "Build community and turn followers into customers across every platform." },
  { key: "ppc", title: "Google Ads (PPC)", icon: "MousePointerClick",
    desc: "High-intent search campaigns engineered for maximum return on ad spend." },
  { key: "meta", title: "Meta Ads", icon: "Facebook",
    desc: "Scroll-stopping creative and precise targeting on Facebook & Instagram." },
  { key: "web", title: "Website Design & Development", icon: "Code2",
    desc: "Fast, beautiful, conversion-first websites that make a lasting impression.", span: "lg:col-span-2" },
  { key: "brand", title: "Branding & Graphic Design", icon: "Palette",
    desc: "Distinct identities and visuals that make your brand impossible to ignore." },
  { key: "content", title: "Content Marketing", icon: "PenLine",
    desc: "Story-driven content that educates, ranks, and drives qualified leads." },
  { key: "email", title: "Email Marketing", icon: "Mail",
    desc: "Automated flows and campaigns that nurture and re-engage on autopilot." },
  { key: "strategy", title: "Marketing Strategy & Consulting", icon: "Compass",
    desc: "Data-backed roadmaps that align every channel to your revenue goals.", span: "lg:col-span-2" },
];

export const WHY = [
  { title: "ROI-Focused Strategies", icon: "TrendingUp", desc: "Every rupee is tracked. We optimize for revenue, not vanity metrics." },
  { title: "Certified Experts", icon: "BadgeCheck", desc: "Google & Meta certified specialists managing your campaigns." },
  { title: "Transparent Communication", icon: "MessagesSquare", desc: "Clear reporting and real conversations — no jargon, no surprises." },
  { title: "Affordable Packages", icon: "Wallet", desc: "Enterprise-grade marketing built for startup and SMB budgets." },
  { title: "Fast Turnaround", icon: "Zap", desc: "Agile execution that gets campaigns live quickly and iterates fast." },
  { title: "Proven Results", icon: "Trophy", desc: "A track record of measurable growth across industries." },
];

export const PROCESS = [
  { no: "01", title: "Discovery", desc: "We dig deep into your business, audience, and competitors to uncover the real opportunities." },
  { no: "02", title: "Strategy", desc: "A tailored, data-driven roadmap mapping every channel to your specific growth goals." },
  { no: "03", title: "Execution", desc: "Our specialists launch campaigns, build assets, and ship work with precision and speed." },
  { no: "04", title: "Optimization", desc: "Continuous testing and refinement to squeeze maximum return from every channel." },
  { no: "05", title: "Growth", desc: "We scale what works, compound the wins, and keep pushing your numbers up and to the right." },
];

export const PORTFOLIO = [
  { title: "E-commerce Fashion Brand", tag: "SEO + Meta Ads",
    image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1000&q=80",
    metric: "+312%", metricLabel: "Revenue Growth", before: "₹4.2L", after: "₹17.3L", period: "6 months" },
  { title: "SaaS Startup Launch", tag: "Google Ads + Content",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1000&q=80",
    metric: "-54%", metricLabel: "Cost Per Lead", before: "₹890", after: "₹410", period: "90 days" },
  { title: "Local Restaurant Chain", tag: "Social + Branding",
    image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1000&q=80",
    metric: "+5.8x", metricLabel: "Return on Ad Spend", before: "1.2x", after: "5.8x", period: "4 months" },
  { title: "D2C Wellness Label", tag: "Full-Funnel Growth",
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=1000&q=80",
    metric: "+248%", metricLabel: "Organic Traffic", before: "9K", after: "31K", period: "8 months" },
];

export const TESTIMONIALS = [
  { name: "Priya Sharma", role: "Founder, Bloom Cosmetics", rating: 5,
    quote: "Digital Madhuraa transformed our online presence completely. Within six months our revenue more than tripled. They genuinely care about our numbers." },
  { name: "Rahul Verma", role: "CEO, TechNova Solutions", rating: 5,
    quote: "The most transparent agency we've ever worked with. Every report is crystal clear and the results speak for themselves. Our cost per lead is down 54%." },
  { name: "Ananya Desai", role: "Marketing Head, UrbanEats", rating: 5,
    quote: "Their strategy team is phenomenal. They understood our brand instantly and delivered a 5.8x ROAS. I recommend them to every founder I know." },
  { name: "Vikram Singh", role: "Director, FitLife Wellness", rating: 5,
    quote: "Professional, fast, and truly results-driven. Our organic traffic nearly quadrupled. Working with Digital Madhuraa is the best marketing decision we made." },
];

export const PRICING = [
  { name: "Starter", price: "₹24,999", period: "/month", tagline: "For local businesses finding their footing online.",
    features: ["SEO for up to 15 keywords", "2 social platforms managed", "8 posts / month", "Monthly performance report", "Email & chat support"],
    highlighted: false },
  { name: "Growth", price: "₹54,999", period: "/month", tagline: "For scaling brands ready to accelerate.",
    features: ["SEO for up to 40 keywords", "4 social platforms managed", "Google Ads + Meta Ads", "16 posts / month", "Bi-weekly reporting + calls", "Dedicated account manager"],
    highlighted: true },
  { name: "Premium", price: "₹99,999", period: "/month", tagline: "For ambitious brands chasing market leadership.",
    features: ["Unlimited keyword SEO", "Full-funnel paid campaigns", "All social platforms", "Custom content & video", "Weekly strategy sessions", "Priority 24/7 support", "Conversion rate optimization"],
    highlighted: false },
];

export const FAQS = [
  { q: "How soon will I see results?", a: "Paid campaigns can generate leads within days, while SEO and content typically compound over 3–6 months. We set clear expectations and milestones from day one." },
  { q: "How does your pricing work?", a: "We offer transparent monthly retainers with no hidden fees. Choose a package that fits your stage, and scale up anytime as you grow. Custom quotes are available for larger needs." },
  { q: "What kind of reporting do I get?", a: "You receive clear, jargon-free reports on the metrics that matter — traffic, leads, revenue and ROAS — plus regular strategy calls with your dedicated manager." },
  { q: "Do you manage campaigns end-to-end?", a: "Yes. From strategy and creative to execution and optimization, our specialists handle everything so you can focus on running your business." },
  { q: "Can I cancel anytime?", a: "Absolutely. Our engagements are month-to-month after the initial onboarding period. We earn your business every single month with results." },
  { q: "Which industries do you work with?", a: "We work with startups, e-commerce brands, local businesses and service providers across many industries. Our data-driven approach adapts to any niche." },
];

export const STATS = [
  { value: "250+", label: "Projects Delivered" },
  { value: "5.8x", label: "Average ROAS" },
  { value: "98%", label: "Client Retention" },
  { value: "12+", label: "Industries Served" },
];
